import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTableContainer = styled.div``;

const SimpleTableContainer = ({ children, className, ...other }) => (
  <StyledTableContainer {...{ children, className }} {...other} />
);

SimpleTableContainer.propTypes = {
  /** Displays any kind of content included between opening and closing tags */
  children: PropTypes.node.isRequired,
  /** Adds additional className to SimpleTableContainer */
  className: PropTypes.string,
};

export { SimpleTableContainer, StyledTableContainer };
